import { ColorPickerProps } from "antd";
import { Color } from "antd/es/color-picker";
import { ColorFormat } from "antd/es/color-picker/interface";
import { makeAutoObservable } from "mobx";
import { validateHex, validateRgb } from "src/common/attrEdit";

const formatMap: Partial<Record<ColorFormat, (value: Color) => string>> = {
  hex: (value) => value.toHexString(),
  rgb: (value) => value.toRgbString(),
  hsb: (value) => value.toHsbString(),
};

export class ColorCardStore {
  constructor() {
    makeAutoObservable(this);
  }

  format: ColorPickerProps["format"] = "hex";

  setFormat(format: ColorPickerProps["format"]) {
    this.format = format;
  }

  validateFormat(value: string | undefined) {
    if (!value || validateHex(value)) {
      this.setFormat("hex");
      return;
    }
    if (validateRgb(value)) {
      this.setFormat("rgb");
    }
  }

  getFormattedValue(value: Color): string[] {
    const { format } = this;
    if (!format || !value) return [""];
    return [formatMap[format]?.(value) ?? ""];
  }
}
